export interface TimeSlotSchedule {
	start_time: string;
	end_time: string;
	original_id: string;
}

export interface GroupedSchedule {
	week_day: number;
	time_slots: Array<TimeSlotSchedule>;
}

export const groupAvailableDatesByWeekday = (
	availableDates: AvailableDates.AvailableDate[],
): GroupedSchedule[] => {
	const groupedByDay = availableDates.reduce(
		(acc, date) => {
			const { week_day, start_time, end_time, id } = date;

			if (!acc[week_day]) {
				acc[week_day] = [];
			}

			acc[week_day].push({
				start_time,
				end_time,
				original_id: id,
			});

			return acc;
		},
		{} as Record<
			number,
			{ start_time: string; end_time: string; original_id: string }[]
		>,
	);

	Object.keys(groupedByDay).forEach((day) => {
		const dayNum = parseInt(day, 10);
		groupedByDay[dayNum].sort(
			(a, b) => parseInt(a.start_time, 10) - parseInt(b.start_time, 10),
		);
	});

	const result = Object.entries(groupedByDay)
		.map(([week_day, time_slots]) => ({
			week_day: parseInt(week_day, 10),
			time_slots,
		}))
		.sort((a, b) => a.week_day - b.week_day);

	return result;
};
